export enum ClientType {
    None = "None",
    Teams = "Teams",
    Kaizala = "Kaizala"
}